import React from "react";
import { Route, Routes } from "react-router-dom";
import MainPlacePage from "./MainPlacePage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditPlacePage from "./AddEditPlacePage";
import ViewPlacePage from "./ViewPlacePage";
import PageNotFound from "../PageNotFound";

const PlaceRouter: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ProtectedRoute element={<MainPlacePage />} />} />
      <Route
        path="create"
        element={<ProtectedRoute element={<AddEditPlacePage />} />}
      />
      <Route
        path=":_id/edit"
        element={<ProtectedRoute element={<AddEditPlacePage />} />}
      />
      <Route
        path=":_id"
        element={<ProtectedRoute element={<ViewPlacePage />} />}
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default PlaceRouter;
